import React from "react";
function NoDataContainer({NoDataMessage, includeButton}) {
  return (
    <div className="no-data-container fade-in-effect-usability">
    <h2 className="no-data-heading">{NoDataMessage}</h2>
    {includeButton == true ? <a href="/new-instance" className="createFirstChatBtn">Create new instance</a> : "" }
    <div className="no-data-inner-section">
      <img className="no-data-image" src="/elite-core-no-live-chats-exist.png"/>
    </div>
  </div>
  );
}
export default NoDataContainer;
